export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/cooking_lessons.7a3a40a.svg";